module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon4.3068cb2a.svg";